import { buildEventFunnelStages } from '../wingmanIntelligenceMetrics';
import ApexFunnelChart from './ApexFunnelChart';

const EventFunnelChart = ({ title = 'Event Funnel', stages = buildEventFunnelStages() }) => (
  <ApexFunnelChart title={title} stages={stages} />
);

export default EventFunnelChart;
